import Vue from "vue";

/**
 * 2019 Acceptance Testing Forms
 *
 * Version 1.0
 */
Vue.component('automatic-time-switch-lighting-controls-2019', require('./NRCA-LTI-02-A/AutomaticTimeSwitch'));
Vue.component('occupant-sensing-lighting-controls-2019', require('./NRCA-LTI-02-A/OccupancySensor'));
Vue.component('continuous-dimming-control-systems-2019', require('./NRCA-LTI-03-A/ContinuousDimmingControlSystems'));
Vue.component('stepped-dimming-control-systems-2019', require('./NRCA-LTI-03-A/SteppedDimmingControlSystems'));
//
Vue.component('demand-responsive-illuminance-measurement-2019', require('./NRCA-LTI-04-A/DemandResponsiveIlluminanceMeasurement'));
Vue.component('demand-responsive-current-measurement-2019', require('./NRCA-LTI-04-A/DemandResponsiveCurrentMeasurement'));
//
Vue.component('institutional-tuning-observation-2019', require('./NRCA-LTI-05-A/InstitutionalTuningObservation'));
Vue.component('institutional-tuning-verification-2019', require('./NRCA-LTI-05-A/InstitutionalTuningVerification'));
//
Vue.component('photo-controls-2019', require('./NRCA-LTO-02-A/PhotoControls'));
Vue.component('automatic-scheduling-controls-and-motion-sensors-used-in-conjunction-2019', require('./NRCA-LTO-02-A/AutomaticSchedulingControlsAndMotionSensorsUsedInConjunction'));
Vue.component('automatic-scheduling-controls-not-used-in-conjunction-with-motion-sensors-2019', require('./NRCA-LTO-02-A/AutomaticSchedulingControlsNotUsedInConjunctionWithMotionSensors'));
//
